
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Spinal_cord_injury_Frankel_functional_class_ASIA_class',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Spinal_cord_injury_Frankel_functional_class_ASIA_class.vue